// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const transient = (category) => (props) => {
    const unPrefixedProps = Object.entries(props).reduce((acc, [key, value]) => {
        let unPrefixedKey = key;
        if (key.startsWith('$'))
            unPrefixedKey = key.substring(1);
        acc[unPrefixedKey] = value;
        return acc;
    }, {});
    return category(unPrefixedProps);
};
export const ellipsis = transient((props) => props.ellipsis > 1
    ? `
    display: -webkit-box !important;
    -webkit-line-clamp: ${props.ellipsis};
    -webkit-box-orient: vertical;
    white-space: normal !important;
  `
    : !props.ellipsis
        ? ''
        : `
    display: block;
    width: 100%;
    max-width: 100vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;
  `);
//# sourceMappingURL=styledHelpers.js.map